<template>
    <div class="checkbox-large font-zero">
        <input 
            :checked="value"
            :id="name" 
            ref="checkbox"
            type="checkbox" 
            class="checkbox-large-input"
            @input="onInput"
        />
        <label 
            :for="name" 
            class="checkbox-large-label"
        >
            <i class="icon-noun_check" />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        onInput() {
            console.log(this.$refs.checkbox.checked)
            this.$emit('input', this.$refs.checkbox.checked)
        }
    }
}
</script>

<style lang="scss">
.checkbox-large {
    display: inline-block;
    
    &-input[type="checkbox"] {
        display: none;

        &:checked {
            & + label {
                > [class^="icon-"] {
                    @include transform-none();
                    opacity: 1;
                }
            }
        }
    }

    &-label {
        @include size(34px);
        display: inline-block;
        position: relative;
        cursor: pointer;
        z-index: 0;

        &:before {
            content: '';
            @include position-cover(-5px);
            @include border-radius(5px);
            @include transform(scale(.9));
            @include transition(.100s);
            background-color: rgba($color-border, .312);
            opacity: 0;
            z-index: -1;
        }

        &:after {
            content: '';
            @include position-cover();
            background-color: $color-bg-light;
            border: 1px solid $color-border;
            z-index: -1;
        }

        > [class^="icon-"] {
            @include transform(scale(.868));
            @include transition(.100s);
            color: $color-primary;
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            position: absolute;
            left: -14px;
            top: 0;
            font-size: 90px;
            line-height: 43px;
            opacity: 0;
        }

        &:hover {
            @media (min-width: $screen-page + 1px) {
                &:before {
                    @include transform-none();
                    opacity: 1;
                }
            }
        }

        &:active {
            &:before {
                @include transform(scale(.868));
                opacity: 1;
            }
        }
    }
}
</style>
